module.exports = __webpack_public_path__ + "static/media/1.5667418d.png";